export default "__VITE_ASSET__B_h0SQnd__"